import {
    EDIT_PROFESSION_FIELD,
    GET_PROFESSION,
    GET_PROFESSIONS,
    GET_PROFESSIONS_CATEGORIES,
    NEW_PROFESSION_FIELD,
    RESET_EDIT_PROFESSION_FIELDS,
    RESET_NEW_PROFESSION_FIELDS,
    RESET_PROFESSION,
    RESET_TOGGLE_PROFESSION_EDITING,
    SEND_EDIT_PROFESSION,
    SEND_NEW_PROFESSION,
    TOGGLE_PROFESSION_CATEGORY,
    TOGGLE_PROFESSION_EDITING
} from "../../constants/ProfessionConstants";
import { FAILURE, SUCCESS } from "../../constants/BaseConstants";

const initialState: ProfessionStateType = {
    professions: [],
    profession: {
        ID: 0,
        post_date: "",
        post_date_gmt: "",
        post_content: "",
        post_title: "",
        post_name: "",
        post_modified: "",
        post_modified_gmt: "",
        post_type: "",
        filter: "",
        fields: {
            what_it_does: "",
            who_is: "",
            how_to_become: "",
            how_much_earns: "",
            where_to_go: ""
        },
        categories: [],
        order: [],
        author_name: ""
    },
    categories: [],
    activeCategories: [],
    isEditing: false,
    editedFields: {
        what_it_does: "",
        who_is: "",
        how_to_become: "",
        how_much_earns: "",
        where_to_go: "",
        post_title: "",
        ID: 0,
        categories: []
    },
    newFields: {
        what_it_does: "",
        who_is: "",
        how_to_become: "",
        how_much_earns: "",
        where_to_go: "",
        post_title: "",
        categories: []
    },
    isLoading: false
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case GET_PROFESSIONS + SUCCESS:
            return {
                ...state,
                professions: action.professions
            };
        case GET_PROFESSION + SUCCESS:
            return {
                ...state,
                profession: action.profession,
                editedFields: {
                    what_it_does: action.profession.fields.what_it_does ? action.profession.fields.what_it_does : initialState.editedFields.what_it_does,
                    who_is: action.profession.fields.who_is ? action.profession.fields.who_is : initialState.editedFields.who_is,
                    how_to_become: action.profession.fields.how_to_become ? action.profession.fields.how_to_become : initialState.editedFields.how_to_become,
                    how_much_earns: action.profession.fields.how_much_earns
                        ? action.profession.fields.how_much_earns
                        : initialState.editedFields.how_much_earns,
                    where_to_go: action.profession.fields.where_to_go ? action.profession.fields.where_to_go : initialState.editedFields.where_to_go,
                    post_title: action.profession.post_title ? action.profession.post_title : initialState.editedFields.post_title,
                    ID: action.profession.ID ? action.profession.ID : initialState.editedFields.ID,
                    categories: action.profession.categories ? action.profession.categories : initialState.editedFields.categories
                }
            };
        case RESET_PROFESSION:
            return {
                ...state,
                profession: initialState.profession,
                editedFields: initialState.editedFields
            };
        case GET_PROFESSIONS_CATEGORIES + SUCCESS:
            return {
                ...state,
                categories: action.categories
            };
        case TOGGLE_PROFESSION_CATEGORY:
            if (!state.activeCategories.includes(action.term_id)) {
                return {
                    ...state,
                    activeCategories: [...state.activeCategories, action.term_id]
                };
            } else {
                const index = state.activeCategories.indexOf(action.term_id);
                return {
                    ...state,
                    activeCategories: [...state.activeCategories.slice(0, index), ...state.activeCategories.slice(index + 1)]
                };
            }
        case RESET_TOGGLE_PROFESSION_EDITING:
            return {
                ...state,
                isEditing: false
            };
        case TOGGLE_PROFESSION_EDITING:
            return {
                ...state,
                isEditing: !state.isEditing,
                editedFields: {
                    what_it_does: state.profession.fields.what_it_does,
                    who_is: state.profession.fields.who_is,
                    how_to_become: state.profession.fields.how_to_become,
                    how_much_earns: state.profession.fields.how_much_earns,
                    where_to_go: state.profession.fields.where_to_go,
                    post_title: state.profession.post_title,
                    ID: state.profession.ID,
                    categories: state.profession.categories ? state.profession.categories : initialState.editedFields.categories
                }
            };
        case EDIT_PROFESSION_FIELD:
            if (action.field === "categories") {
                if (!state.editedFields.categories.map((category: ProfessionCategory) => category.term_id).includes(action.data.term_id)) {
                    return {
                        ...state,
                        editedFields: {
                            ...state.editedFields,
                            categories: [...state.editedFields.categories, action.data]
                        }
                    };
                } else {
                    const index = state.editedFields.categories.map((category: ProfessionCategory) => category.term_id).indexOf(action.data.term_id);
                    return {
                        ...state,
                        editedFields: {
                            ...state.editedFields,
                            categories: [...state.editedFields.categories.slice(0, index), ...state.editedFields.categories.slice(index + 1)]
                        }
                    };
                }
            }
            return {
                ...state,
                editedFields: {
                    ...state.editedFields,
                    [action.field]: action.data
                }
            };
        case NEW_PROFESSION_FIELD:
            if (action.field === "categories") {
                if (!state.newFields.categories.map((category: ProfessionCategory) => category.term_id).includes(action.data.term_id)) {
                    return {
                        ...state,
                        newFields: {
                            ...state.newFields,
                            categories: [...state.newFields.categories, action.data]
                        }
                    };
                } else {
                    const index = state.newFields.categories.map((category: ProfessionCategory) => category.term_id).indexOf(action.data.term_id);
                    return {
                        ...state,
                        newFields: {
                            ...state.newFields,
                            categories: [...state.newFields.categories.slice(0, index), ...state.newFields.categories.slice(index + 1)]
                        }
                    };
                }
            }
            return {
                ...state,
                newFields: {
                    ...state.newFields,
                    [action.field]: action.data
                }
            };
        case RESET_EDIT_PROFESSION_FIELDS:
            return {
                ...state,
                editedFields: initialState.editedFields
            };
        case RESET_NEW_PROFESSION_FIELDS:
            return {
                ...state,
                newFields: initialState.newFields
            };
        case SEND_EDIT_PROFESSION:
        case SEND_NEW_PROFESSION:
            return {
                ...state,
                isLoading: true
            };
        case SEND_EDIT_PROFESSION + FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case SEND_EDIT_PROFESSION + SUCCESS:
            return {
                ...state,
                isLoading: false,
                isEditing: false,
                profession: action.profession,
                editedFields: {
                    what_it_does: action.profession.fields.what_it_does ? action.profession.fields.what_it_does : initialState.editedFields.what_it_does,
                    who_is: action.profession.fields.who_is ? action.profession.fields.who_is : initialState.editedFields.who_is,
                    how_to_become: action.profession.fields.how_to_become ? action.profession.fields.how_to_become : initialState.editedFields.how_to_become,
                    how_much_earns: action.profession.fields.how_much_earns
                        ? action.profession.fields.how_much_earns
                        : initialState.editedFields.how_much_earns,
                    where_to_go: action.profession.fields.where_to_go ? action.profession.fields.where_to_go : initialState.editedFields.where_to_go,
                    post_title: action.profession.post_title ? action.profession.post_title : initialState.editedFields.post_title,
                    ID: action.profession.ID ? action.profession.ID : initialState.editedFields.ID,
                    categories: action.profession.categories ? action.profession.categories : initialState.editedFields.categories
                }
            };
        case SEND_NEW_PROFESSION + FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case SEND_NEW_PROFESSION + SUCCESS:
            return {
                ...state,
                isLoading: false,
                newFields: initialState.newFields
            };
        default:
            return state;
    }
};
